import styled from 'styled-components'
import PropTypes from 'prop-types'

import { PB, hexToHsl } from '@h2/components/colors'
import { features } from '@h2/components/media'

const [hue, sat, light] = hexToHsl(PB)
const Div = styled.div`
  position: fixed;
  width: 100%;
  bottom: 0;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: hsla(${hue}, ${sat}%, ${light}%, 0.5);

  @media (${features.minWidth.laptop}) {
    display: none;
  }
`
const Overlay = ({ navHeight }) => {
  return <Div navHeight={navHeight} />
}

Overlay.propTypes = {
  navHeight: PropTypes.string.isRequired
}

export { Overlay }
